<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center">
      <v-btn color="primary" tile @click="getData">
        <v-icon small>mdi-refresh</v-icon> 刷新
      </v-btn>
      <v-btn color="success" tile @click="add">
        <v-icon small>mdi-plus</v-icon> 新增项目
      </v-btn>
    </div>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="list" :pagination="false" :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="state" slot-scope="text, record">
          <a-tag v-if="record.state === 0" color="gray">未开始</a-tag>
          <a-tag v-if="record.state === 1" color="blue">进行中</a-tag>
          <a-tag v-if="record.state === 2" color="green">已完成</a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn text tile color="success" @click="edit(record)"> 编辑 </v-btn>
            <a-popconfirm title="确认删除项目?" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)" placement="left">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <a-modal :title="title" :visible="modal" :confirm-loading="saving" @ok="save" okText="确定" @cancel="cancelsave"
      cancelText="取消">
      <a-form-model ref="formref" :model="form" :rules="rules" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14 }">
        <a-form-model-item label="项目名称" prop="name">
          <a-input v-model="form.name" placeholder="项目名称" size="large" style="width:100%;" :disabled="saving">
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="开始时间" prop="start_date">
          <a-date-picker v-model="form.start_date" :locale="locale" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
            placeholder="开始时间" @change="onChange" @ok="onOk" size="large" style="width:100%;" :disabled="saving" />
        </a-form-model-item>
        <a-form-model-item label="结束时间" prop="end_date">
          <a-date-picker v-model="form.end_date" :locale="locale" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
            placeholder="结束时间" @change="onChange" @ok="onOk" size="large" style="width:100%;" :disabled="saving" />
        </a-form-model-item>
        <a-form-model-item label="合同金额" prop="amount">
          <a-input v-model="form.amount" type="number" placeholder="合同金额" suffix="元" size="large" style="width:100%;"
            :disabled="saving" />
        </a-form-model-item>
        <a-form-model-item label="预计利润" prop="profit">
          <a-input v-model="form.profit" type="number" placeholder="预计利润" suffix="元" size="large" style="width:100%;"
            :disabled="saving" />
        </a-form-model-item>
        <a-form-model-item label="项目备注" prop="remark">
          <a-textarea v-model="form.remark" placeholder="项目备注" :auto-size="{ minRows: 5, maxRows: 5 }"
            :disabled="saving" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="state">
          <a-select v-model="form.state" :options="states" placeholder="请选择" size="large" style="width:100%;"
            :disabled="saving">
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </v-container>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
export default {
  name: "Projects",
  data() {
    return {
      locale,
      pages: [
        { text: "20/页", value: 20 },
        { text: "50/页", value: 50 },
        { text: "100/页", value: 100 },
        { text: "200/页", value: 200 },
      ],
      states: [
        { value: 0, label: "未开始" },
        { value: 1, label: "进行中" },
        { value: 2, label: "已完成" },
      ],
      valid: true,
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "项目名称", dataIndex: "name", scopedSlots: { customRender: "name" }, width: 150, align: "center" },
        { title: "开始时间", dataIndex: "start_date", scopedSlots: { customRender: "start_date" }, width: 120, align: "center" },
        { title: "结束时间", dataIndex: "end_date", scopedSlots: { customRender: "end_date" }, width: 120, align: "center" },
        { title: "合同金额", dataIndex: "amount", scopedSlots: { customRender: "amount" }, width: 120, align: "center" },
        { title: "预计利润", dataIndex: "profit", scopedSlots: { customRender: "profit" }, width: 120, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 200 },
        { title: "状态", dataIndex: "state", scopedSlots: { customRender: "state" }, width: 100, align: "center" },
        { title: "创建人", dataIndex: "create_by", scopedSlots: { customRender: "create_by" }, width: 100, align: "center" },
        { title: "创建时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 180, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 150, align: "center", fixed: 'right' },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      modal: false,
      form: {},
      title: "",
      saving: false,
      rules: {
        name: [
          { required: true, message: '项目名称不能为空', trigger: 'blur' },
        ],
        start_date: [
          { required: true, message: '开始时间不能为空', trigger: 'change' },
        ],
        end_date: [
          { required: true, message: '结束时间不能为空', trigger: 'change' },
        ],
        amount: [
          { required: true, message: '合同金额不能为空', trigger: 'blur' },
        ],
        profit: [
          { required: true, message: '预计利润不能为空', trigger: 'blur' },
        ],
        remark: [
          { required: true, message: '项目备注不能为空', trigger: 'blur' },
        ],
        state: [
          { required: true, message: '状态不能为空', trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
    page() {
      this.getData();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getData();
    },
  },
  mounted() {
    this.height = window.innerHeight - 180;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 180;
    };
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
  },
  activated() {
    this.getData();
  },
  methods: {
    getData() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/projectplan/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
          this.states = res.data.states;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    initform() {
      return {
        _id: "",
        name: "",
        start_date: "",
        end_date: "",
        amount: "",
        profit: "",
        remark: "",
        state: undefined,
      };
    },
    onChange(value, dateString) {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    },
    onOk(value) {
      console.log('onOk: ', value, this.chargeForm);
    },
    add() {
      this.form = this.initform();
      this.title = "新增项目";
      this.modal = true;
    },
    edit(item) {
      this.form = _.pick(item, _.keys(this.initform()));
      this.title = "编辑项目";
      this.modal = true;
    },
    save() {
      this.$refs.formref.validate(valid => {
        if (valid) {
          this.$toast.loading({ message: "" });
          this.$api.doAPI("/projectplan/save", { dataForm: this.form }).then((res) => {
            this.$toast.clear();
            if (res.code === 0) {
              this.modal = false;
              this.getData();
            } else {
              this.$alert(res.msg);
            }
          }).catch((err) => {
            this.$toast.clear();
            console.error(err);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancelsave() {
      this.$refs.formref.resetFields();
      this.modal = false;
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/projectplan/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getData();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
